<template>
  <v-form ref="form">
    <v-card-text>
      <v-row>
        <v-col>
          <v-text-field filled
                        hide-details="auto"
                        v-bind:label="$t('title')"
                        v-bind:rules="[ rules.required ]"
                        v-model="category.text" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field filled
                        hide-details="auto"
                        type="number"
                        v-bind:label="$t('sort')"
                        v-bind:rules="[ rules.required ]"
                        v-model="category.sort" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-form>
</template>

<script>
  export default {
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('global.pleaseFillOutThisField')
        }
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'CategoryDetails',
    props: {
      category: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "sort": "Sortierung",
      "title": "Bezeichnung"
    },
    "en": {
      "sort": "Sort",
      "title": "Title"
    }
  }
</i18n>